import React from "react";
import PlansSectionHeader from "./PlansSectionHeader";
import GoToContent from "./GoToContent";

const PlansSectionActivePlan = () => {
  return (
    <>
      <PlansSectionHeader
        title="Thanks for your purchase."
        description="Enjoy your content."
      />
      <hr className="w-full border-gray-500 border-b-1 my-8" />

      <div className="flex flex-col justify-center items-center px-8">
        <GoToContent />
      </div>
    </>
  );
};

export default PlansSectionActivePlan;
